export function formatCurrency(_temp) {
  let {
    amount = 0,
    currency,
    locale,
    decimalCount
  } = _temp === void 0 ? {} : _temp;
  const amountNumber = Number(amount);
  if (currency) {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      unitDisplay: 'narrow',
      currency,
      minimumFractionDigits: decimalCount,
      maximumFractionDigits: decimalCount ?? getPrecision(amountNumber)
    }).format(amountNumber);
  }
  if (decimalCount) {
    return amountNumber.toFixed(decimalCount);
  }
  return String(amount);
}
function getPrecision(amount) {
  var _amount$toString$spli;
  return ((_amount$toString$spli = amount.toString().split('.')[1]) == null ? void 0 : _amount$toString$spli.length) || 0;
}
//# sourceMappingURL=format-currency.js.map